"use strict";
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.unrefTimer = void 0;
/**
 * @deprecated please copy this code to your implementation instead, this function will be removed in the next major version of this package.
 * @param timer
 */
function unrefTimer(timer) {
    if (typeof timer !== 'number') {
        timer.unref();
    }
}
exports.unrefTimer = unrefTimer;
//# sourceMappingURL=timer-util.js.map